import './index.scss';

import { Component, ContextType, ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { BraxSize } from '../../types';
import ModalsContext from '../BraxModals/context';
import { BraxIcon } from '../BraxIcon';

export type BraxModalProps = {
    className: string,
    size: BraxSize | 'full',
    open: boolean,
    overlay: boolean,
    backdrop: boolean,
    close: boolean,
    children: ReactNode,
    onClose?: () => void
};

export class BraxModal extends Component<BraxModalProps> {

    static defaultProps = {
        className: '',
        size: 'md',
        open: true,
        overlay: true,
        backdrop: true,
        close: true
    };

    static contextType = ModalsContext;

    declare context: ContextType<typeof ModalsContext>

    onClose() {
        if (this.props.onClose)
            this.props.onClose();
    }

    render() {
        if (!this.context.ref.current)
            return null;

        return createPortal(
            <div className={`brax-modal ${this.props.open ? 'open' : ''} ${this.props.className}`}>
                { this.props.overlay ? (
                    <div
                        className={`overlay ${this.props.backdrop ? 'backdrop' : ''}`}
                        onClick={() => this.props.backdrop ? this.onClose() : void 0}
                    />
                ) : null }

                <div className={`dialog ${this.props.size}`}>
                    { this.props.close ? (
                        <BraxIcon icon="close" onClick={() => this.onClose()} />
                    ) : null }

                    { this.props.children }
                </div>
            </div>,
            this.context.ref.current
        );
    }

}
